// Where a hover card hangs. The geometric half of `HoverCard.tsx`, as
// arithmetic over rects, so it can be tested without a browser.
//
// **A card inside a panel opens beside the panel** (designer ruling, U6 second
// review 2026-09-02). `placement` alone answers "which way from the trigger",
// and inside a 240px card of stacked rows that is not enough: `right` of a
// control at the panel's left edge is still *inside* the panel, on the heading
// or the tiles below it. The direction was right and the anchor was wrong.
//
// So the anchor becomes the trigger's vertical band projected onto the
// container's right edge — a zero-width rect at `container.right`, at the
// trigger's own height. The card keeps the caller's placement and its offset,
// so it lands just outside the panel, level with the control it explains, and
// the panel is never something the player has to reach past.

/** What this needs off a rect. A `DOMRect` satisfies it. */
export interface RectLike {
  top: number;
  bottom: number;
  height: number;
  right: number;
}

/** Every field Popper reads off a virtual element's rect. */
export interface AnchorRect {
  x: number;
  y: number;
  top: number;
  right: number;
  bottom: number;
  left: number;
  width: number;
  height: number;
}

/**
 * The trigger's band, on the container's outer edge.
 *
 * Zero width on purpose: an anchor with width would let the offset measure
 * from the wrong side of it, and there is nothing here to point *at* — the
 * thing being explained is the trigger, and the edge is only where the card is
 * allowed to start.
 */
export function besideRect(trigger: RectLike, container: RectLike): AnchorRect {
  const edge = container.right;
  return {
    x: edge,
    y: trigger.top,
    left: edge,
    right: edge,
    width: 0,
    top: trigger.top,
    bottom: trigger.bottom,
    height: trigger.height
  };
}
